import theme from '@ifca-root/react-component/src/assets/theme'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import { SearchBar } from '@ifca-root/react-component/src/components/SpecialBar/SearchBar'
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { DepreciationDetail } from './DepreciationDetail'
import { AccountFooter } from '@ifca-root/react-component/src/components/Footer/AccountFooter'
import {
  useGetAssetDepreciableListingLazyQuery,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'

export const DepreciationGenerateList = (props: any) => {
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()
  const [TotalLength, setTotalLength] = useState(0)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'fa_depreciation' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const docNumChecker = getDocumentNumberHeader?.length === 0

  const [
    loadAssetDepreciableListing,
    { loading: getAssetDepreciableListingLoading },
  ] = useGetAssetDepreciableListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAssetDepreciableListing }) => {
      if (getAssetDepreciableListing?.Data?.length > 0) {
        setOriginalListing([
          ...filteredList,
          ...getAssetDepreciableListing?.Data,
        ])
      }

      setTotalLength(getAssetDepreciableListing?.TotalLength)
    },
  })

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */

  const [depreciateIDs, setDepreciateIDs] = useState<Set<any>>(new Set([]))
  const [openExitConf, setOpenExitConf] = useState(null)
  const [selectedDepreciation, setSelectedDepreciation] = useState<any[]>([])
  const selectedDepreciate = Array.from(depreciateIDs)
  const [timer, setTimer] = useState(null)

  /* -------------------------------------------- */
  /*                   USEEFFECT                  */
  /* -------------------------------------------- */

  useEffect(() => {
    loadAssetDepreciableListing({
      variables: {
        CompanyID: CompanyID,
        take: 30,
        skip: 0,
        searchValue: getSearch?.name || '',
      },
    })
  }, [])

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */

  const handleSelectAll = e => {
    let temp = depreciateIDs
    if (e.target.checked) {
      filteredList.map(v => {
        temp.add(v?.fa_asset_id)
      })
    } else {
      temp.clear()
    }
    setDepreciateIDs(new Set(temp))
  }

  const handleCheckBoxChange = (e: any, depreciateID) => {
    let temp = depreciateIDs
    if (!temp.has(depreciateID)) temp.add(depreciateID)
    else temp.delete(depreciateID)

    setDepreciateIDs(new Set(temp))
  }

  /* -------------------------------------------- */
  /*                   EXIT CONF                  */
  /* -------------------------------------------- */

  const hasChanges = () => {
    if (depreciateIDs?.size === 0) return false
    else return true
  }

  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadAssetDepreciableListing({
          variables: {
            CompanyID: CompanyID,
            take: 30,
            skip: 0,
            searchValue: change,
          },
        })
      }, 1000)
    )
  }

  /* -------------------------------------------- */
  /*                    ONSUBMIT                  */
  /* -------------------------------------------- */

  const onSubmit = () => {
    let selectedDepreciate = Array.from(depreciateIDs)

    if (selectedDepreciate.length === 0) {
      alert('Please select at least one asset to generate depreciation.')
      return
    }

    const depreciationData = filteredList.filter(item =>
      depreciateIDs.has(item.fa_asset_id)
    )

    localStorage.setItem(
      'selectedDepreciationGenerate',
      JSON.stringify(depreciationData)
    )

    setSelectedDepreciation(depreciationData)

    history.push(
      `/fixed-assets/${CompanyID}/depreciation/generate-depreciation/summary-depreciation`
    )

    setDepreciateIDs(new Set([]))
  }

  return (
    <>
      {docNumHeaderLoading && <Loading />}
      {getAssetDepreciableListingLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          hasChanges() === true
            ? setOpenExitConf(true)
            : history.push(`/fixed-assets/${CompanyID}/depreciation`)
          localStorage.removeItem(`searchFilter`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Generate Depreciation', current: true },
        ]}
        rightRouteSegments={[{ name: 'New', current: true }]}
      />

      <div className="search-filter with-dropdown-filter ">
        <SearchBar
          borderRadius="4px"
          onChangeAction={e => {
            changeDelay(e.target.value)
            localStorage.setItem(
              'searchFilter',
              JSON.stringify({
                name: e?.target?.value,
              })
            )
          }}
          defaultValue={getSearch?.name ? getSearch?.name : ''}
          onCloseAction={() => {
            handleSearch('', [])
            setOriginalListing([])
            loadAssetDepreciableListing({
              variables: {
                CompanyID: CompanyID,
                take: 30,
                skip: 0,
                searchValue: '',
              },
            })
          }}
          isDefaultValue={!!getSearch}
        />
      </div>

      <ContentWrapper
        footer
        overflow
        style={{ marginTop: isDesktop ? '70px' : '-7px' }}
      >
        <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
          <Checkbox
            onChange={handleSelectAll}
            color="primary"
            value={''}
            checked={
              filteredList?.length > 0 &&
              depreciateIDs?.size === filteredList?.length
            }
            style={{ marginLeft: '-5px', marginTop: '-5px' }}
          />
          <span style={{ marginLeft: '9px' }}>Select All</span>
        </span>
        <List className="core-list">
          {getAssetDepreciableListingLoading ? (
            <EmptyList title="Loading..." subtitle="Please wait" />
          ) : filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="No depreciable assets available."
            />
          ) : (
            <>
              {advancedFilterList(filteredList).map((el, index) => {
                return (
                  <CardExpansion
                    key={el?.fa_asset_id || index}
                    summary={
                      <ListItem style={{ padding: '12px 16px', width: '100%' }}>
                        <FormControl
                          component="fieldset"
                          style={{ width: '16px', flexShrink: 0 }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                value={el?.fa_asset_id}
                                onChange={e => {
                                  handleCheckBoxChange(e, el?.fa_asset_id)
                                }}
                                onClick={e => e.stopPropagation()}
                                checked={depreciateIDs?.has(el?.fa_asset_id)}
                                color="primary"
                                style={{
                                  marginLeft: '10px',
                                  marginRight: '-5px',
                                }}
                              />
                            }
                            label=""
                            name="check"
                          />
                        </FormControl>

                        <ListItemText
                          style={{
                            marginLeft: '25px',
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                          }}
                          primary={
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: '12px',
                                width: '100%',
                              }}
                            >
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  className="xxTitle"
                                  style={{
                                    marginBottom: '4px',
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#000',
                                    lineHeight: '1.4',
                                  }}
                                >
                                  {el?.DocNo || '-'}
                                </div>
                                <div
                                  className="desc"
                                  style={{
                                    marginBottom: '4px',
                                    // fontSize: '13px',
                                    color: '#333',
                                    lineHeight: '1.5',
                                  }}
                                >
                                  {el?.asset_card_no || '-'}
                                </div>
                                <div
                                  className="desc"
                                  style={{
                                    color: '#666',
                                    lineHeight: '1.4',
                                  }}
                                >
                                  {el?.Category?.name || ''}
                                </div>
                              </div>

                              <div
                                style={{
                                  flexShrink: 0,
                                  textAlign: 'right',
                                  paddingTop: '2px',
                                }}
                              >
                                <div
                                  className="c-orange"
                                  style={{
                                    fontSize: '11px',
                                    marginBottom: '2px',
                                  }}
                                >
                                  {el?.net_amount ? amtStr(el.net_amount) : '-'}
                                </div>
                              </div>
                            </div>
                          }
                        />
                      </ListItem>
                    }
                  >
                    <DepreciationDetail CompanyID={CompanyID} listEl={el} />
                  </CardExpansion>
                )
              })}
            </>
          )}
        </List>
      </ContentWrapper>

      <AccountFooter
        options={[
          {
            name: (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                Next
                {selectedDepreciate.length > 0 ? (
                  <span
                    style={{
                      marginLeft: '8px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      color: '#000',
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                    }}
                  >
                    {depreciateIDs.size}
                  </span>
                ) : null}
              </span>
            ),
            onClick: () => {
              if (docNumChecker) {
                setOpenSnackBar(true)
                setSnackBarMsg(SystemMsgs.errorNumberingStructure())
              } else {
                onSubmit()
              }
            },
            color: 'primary',
            props: {
              disabled: selectedDepreciate.length === 0,
            },
          },
        ]}
      />
    </>
  )
}
